import axios from './axios';
import { handleApiError } from './apiErrorHandler';

export default {
    searchLeads: async (payload) => {
        try {
            const response = await axios.post('/lead/prospects/leads', payload, {
            });
            return { success: true, data: response.data };
        } catch (error) {
            return handleApiError(error);
        }
    },

    getDashboard: async (payload) => {
        try {
            const response = await axios.post(
                "/lead/prospects/dashboard",
                payload
            );

            return {
                success: true,
                data: response.data
            };
        } catch (error) {
            return handleApiError(error);
        }
    },

    searchEmployeeLeads: async (payload) => {
        try {
            const response = await axios.post('/lead/prospects/employee/leads', payload, {
            });
            return { success: true, data: response.data };
        } catch (error) {
            return handleApiError(error);
        }
    },

    getDistinctValues: async (fields) => {
        try {
            const response = await axios.post(
                '/lead/prospects/distinct/master',
                { fields },
            );

            return { success: true, data: response.data };
        } catch (error) {
            return handleApiError(error);
        }
    },
};